<template>
    <header class="header" v-if="setup != null" id="header" :class="{'hideHeader' : !isVisisbleOnScrollEvent}">
        <div class="container">
            <div class="header-container" v-if="!isMobileChecker">

                <div class="mobile-menu" :class="{open: openSendwich}" @click="openMobileMenu(!openSendwich)">
                    <span></span>
                </div>
                
                <div class="logo-dial">
                    <router-link to="/" @click.native="startLoader">
                        <img :src="setup.logo_dial" alt="DIAL STROY KZ">
                    </router-link>
                </div>

                <div class="header-nav">
                    <ul>
                        <li v-for="item in setup.header_nav">
                            <router-link :to="item.href">{{ item.name }}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="btn-hypothec">
                    <router-link to="/payment-types">
                        <span>{{setup.header_hypothec_btn}}</span>
                    </router-link>
                </div>

                <div class="lang-selector">
                    <div class="current-lang" @click="langOpen = !langOpen" :class="{'open': langOpen}">
                        <div v-if="globalLang == ''">RU <span></span></div>
                        <div v-if="globalLang == 'kz/'">KZ <span></span></div>
                    </div>
                    <div class="dropdown-lang" :class="{'open': langOpen}">
                        <ul>
                            <li v-if="globalLang != ''"><a href="#" @click.prevent="setLocale('')">RU</a></li>
                            <li v-if="globalLang != 'kz/'"><a href="#" @click.prevent="setLocale('kz/')">KZ</a></li>
                        </ul>
                    </div>
                </div>

                <div class="phone-container">
                    <a :href="'tel:' + setup.header_phone.code + setup.header_phone.phone"><span>{{ setup.header_phone.code }}</span> {{setup.header_phone.phone }}</a>
                    <div class="time-work"><p>{{ setup.header_time_work }}</p></div>
                </div>

                <div class="user-links">
                    <!-- <div class="item">
                        <router-link :to="{ name : 'search' }" @click.native="startLoader">
                            <svgIcon name="search" class="icon-search"/>
                        </router-link>
                    </div> -->
                    <div class="item item-phone">
                        <a :href="'tel:' + setup.header_phone.code + setup.header_phone.phone">
                            <svgIcon name="phone" class="icon-phone"/>
                        </a>
                    </div>
                    <div class="item">
                        <!-- :class="{'active' : countFavorite > 0}" -->
                        <router-link :to="{ name : 'favorite' }" @click.native="startLoader">
                            <svgIcon name="favorite" class="icon-favorite"/>
                        </router-link>
                    </div>
                </div>

            </div>
            <div class="header-container-mobile" v-else>
                <div class="logo-dial">
                    <router-link to="/" @click.native="startLoader">
                        <img :src="setup.logo_dial" alt="DIAL STROY KZ">
                    </router-link>
                </div>
                <div class="user-links">
                    <div class="item">
                        <a :href="'tel:' + setup.header_phone.code + setup.header_phone.phone">
                            <svgIcon name="phone" class="icon-phone"/>
                        </a>
                    </div>
                    <!-- <div class="item item">
                        <router-link :to="{ name : 'search' }" @click.native="startLoader">
                            <svgIcon name="search" class="icon-search"/>
                        </router-link>
                    </div> -->
                    <div class="item">
                        <!-- :class="{'active' : countFavorite > 0}" -->
                        <router-link :to="{ name : 'favorite' }" @click.native="startLoader">
                            <svgIcon name="favorite" class="icon-favorite"/>
                        </router-link>
                    </div>
                </div>
                <div class="lang-selector">
                    <div class="current-lang" @click="langOpen = !langOpen" :class="{'open': langOpen}">
                        <div v-if="globalLang == ''">RU <span></span></div>
                        <div v-if="globalLang == 'kz/'">KZ <span></span></div>
                    </div>
                    <div class="dropdown-lang" :class="{'open': langOpen}">
                        <ul>
                            <li v-if="globalLang != ''"><a href="#" @click.prevent="setLocale('')">RU</a></li>
                            <li v-if="globalLang != 'kz/'"><a href="#" @click.prevent="setLocale('kz/')">KZ</a></li>
                        </ul>
                    </div>
                </div>
                <div class="mobile-menu" :class="{open: openSendwich}" @click="openMobileMenu(!openSendwich)">
                    <span></span>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'AppHeader',
        components: {
            svgIcon,
        },
        data () {
            return {
                langOpen: false,
                globalLang: window.GlobalLang, 
                scrollPosition: 0,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            // countFavorite: 'loadFavoriteCount',
            openSendwich: 'loadOpenSendwich',
            // openPhonesCity: 'loadPhonesCityOpen',
            // URLrocketLC: 'loadUrlRocketLC',
            isMobileChecker: 'loadIsMobileChecker',
            isVisisbleOnScrollEvent: 'loadIsVisibleScrollEvent',
        }),
        methods: {
            setLocale(lang) {
                localStorage.setItem('languageDial', lang);
                document.location.reload(true);
            },
            openMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            startLoader() {
                // this.$parent.$refs.topProgress.start();
                this.closeMobileMenu();
            },
            closeMobileMenu() {
                this.$store.commit('Open_Sendwich', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            },
            handleScroll() {
                var currentScrollPosition = window.scrollY
                if(currentScrollPosition < this.scrollPosition){
                    // console.log("Scrolling up");
                    this.$store.commit('setVisibleParamOnScrollEvent', true);
                    //your desire logic
                    if (currentScrollPosition < 20) {
                        this.$store.commit('setHeaderBGOnScrollEvent', false);
                    } 
                }
                else{
                    // this.showFullNav = false
                    // console.log("Scrolling down", currentScrollPosition);
                    if (currentScrollPosition > 20) {
                        this.$store.commit('setVisibleParamOnScrollEvent', false);
                        this.$store.commit('setHeaderBGOnScrollEvent', true);
                    } else {
                        this.$store.commit('setVisibleParamOnScrollEvent', true);
                        this.$store.commit('setHeaderBGOnScrollEvent', false);
                    }
                    //your desire logic 
                }
                this.scrollPosition = window.scrollY
            }, 
        },
        beforeCreate() {
        },
        created () {
            
        },
        mounted () {
            window.addEventListener("scroll", this.handleScroll);
            // this.isMobileCheck();
            // this.checkResize();
            // this.$store.watch(
            //     (state) => state.pageSetup,
            //     (newValue) => {
            //         if (newValue != null) {
            //             this.setCockieStorage();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/header/header.scss';
    @import '@/styles/components/header/header-respond.scss';
    // @import '@/styles/respond/header/respond-header.scss';
</style>